'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'cloud';
var width = 576;
var height = 512;
var aliases = [9729];
var unicode = 'f0c2';
var svgPathData = ['M32 336l0 112 512 0 0-96c0-38.3-22.4-71.3-54.9-86.8l-9.1-4.3 0-60.9c0-48.6-39.4-88-88-88-13.6 0-26.4 3.1-37.9 8.5l-12.6 6-7.7-11.7c-20-30.6-54.6-50.8-93.8-50.8-61.9 0-112 50.1-112 112l0 48.4-12 3.1C67.7 240 32 283.8 32 336z', 'M240 64c-61.9 0-112 50.1-112 112l0 48.4-12 3.1C67.7 240 32 283.8 32 336l0 112 512 0 0-96c0-38.3-22.4-71.3-54.9-86.8l-9.1-4.3 0-60.9c0-48.6-39.4-88-88-88-13.6 0-26.4 3.1-37.9 8.5l-12.6 6-7.7-11.7C313.8 84.2 279.3 64 240 64zM96 176c0-79.5 64.5-144 144-144 45.7 0 86.5 21.3 112.8 54.5 12.3-4.2 25.5-6.5 39.2-6.5 66.3 0 120 53.7 120 120l0 41.1c38.2 22.1 64 63.5 64 110.9l0 128-576 0 0-144c0-62.7 40.1-116 96-135.8L96 176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloud = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;